import { api } from './api/api';
class DefaultApiPolicy {
    constructor(target) {
        this.called = new Set();
        this.target = target;
    }
    exclude() {
        return false;
    }
    canRecall() {
        return true;
    }
}
export class ApiManager {
    constructor(impls) {
        this.impls = impls;
        this.apiPolicies = {};
        this.impls.forEach(i => {
            const logicalApi = api.requireLogicalApi(i);
            this.registerApiPolicy(new DefaultApiPolicy(i));
            if (!logicalApi) {
                console.warn('[api] ' + i + ' has a impl of undefined');
            }
            else {
                console.log('[api] ' + i + ' installed  ');
            }
        });
    }
    registerApiPolicy(policy) {
        if (!policy || !policy.target) {
            return;
        }
        if (!this.apiPolicies[policy.target]) {
            this.apiPolicies[policy.target] = policy;
        }
        else {
            const origin = this.apiPolicies[policy.target];
            this.apiPolicies[policy.target] = Object.assign(Object.assign({}, origin), policy);
        }
    }
    judgeCall(apiPolicy, type, ev) {
        if (!apiPolicy) {
            return true;
        }
        const exclude = !(ev === null || ev === void 0 ? void 0 : ev.ignorePath) && !!apiPolicy.exclude && apiPolicy.exclude(type, ev);
        const recall = !!apiPolicy.canRecall && apiPolicy.canRecall(type, ev);
        const called = apiPolicy.called.has(type);
        const b = !exclude && (recall || !called);
        if (type !== 'onBlur' && type !== 'onFocus') {
            console.log('[api] test policy for  ' + apiPolicy.target + '.' + type + ' ' + location.href + ' result :' + b, { exclude, recall, called });
        }
        return b;
    }
    triggerApiLifeCycleEvent(ev) {
        if (!ev || !ev.event) {
            return;
        }
        const type = ev.event;
        if (type !== 'onBlur' && type !== 'onFocus') {
            console.log('[api] trigger api life cycle: ' + type);
        }
        this.impls.forEach(i => {
            const logicalApi = api.requireLogicalApi(i);
            let apiPolicy;
            if (this.apiPolicies && i in this.apiPolicies) {
                apiPolicy = this.apiPolicies[i];
            }
            const needCall = this.judgeCall(apiPolicy, type, ev);
            if (needCall && logicalApi) {
                try {
                    logicalApi[type] &&
                        typeof logicalApi[type] === 'function' &&
                        logicalApi[type].apply(logicalApi, [ev]);
                }
                catch (ex) {
                    console.warn('[api] error occured when call api lifecycle function ' + type + ' for ' + i, ex);
                }
                if (apiPolicy && apiPolicy.called) {
                    apiPolicy.called.add(type);
                }
            }
            else if (type !== 'onBlur' && type !== 'onFocus') {
                console.log('[api] ignore call api ' + i + ' for function ' + type);
            }
            if (!logicalApi) {
                console.warn('[api] ' + i + ' has a impl of undefined');
            }
        });
        this.triggerRelatedApi(ev);
    }
    triggerRelatedApi(ev) {
        if (ev.event === 'afterLogin') {
            const initEv = Object.assign(Object.assign({}, ev), {
                event: 'init',
                ignorePath: true,
            });
            this.triggerApiLifeCycleEvent(initEv);
            const afterInitEv = Object.assign(Object.assign({}, ev), {
                event: 'afterInit',
                ignorePath: true,
            });
            this.triggerApiLifeCycleEvent(afterInitEv);
            const afterLoadFinishEv = Object.assign(Object.assign({}, ev), {
                event: 'afterLoadFinish',
                ignorePath: true,
            });
            this.triggerApiLifeCycleEvent(afterLoadFinishEv);
        }
    }
}
